import React, { useEffect, useState } from "react";
import { Textarea } from "../../ui/textarea";
import Modal from "../../Modal";

import { getAllBgs } from "../../../utils/photogenix/utils";

import "./style.css";

export default function Backgrounds() {
  const [isLoading, setIsLoading] = useState(false);
  const [backgrounds, setBackgrounds] = useState<any[]>([]);
  const [selectedBg, setSelectedBg] = useState<any | null>(null);

  useEffect(() => {
    getbackgrounds();
  }, []);

  const getbackgrounds = async () => {
    try {
      setIsLoading(true);
      const response = await getAllBgs();
      setBackgrounds(response);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const updateBgPrompt = (value: string, category: string) => {
    const updatedBackgrounds = backgrounds.map((background) => {
      if (background._id === selectedBg._id) {
        const data = {
          ...background,
          options: {
            ...background.options,
            [category]: {
              ...background.options[category],
              prompt: value,
            },
          },
        };
        setSelectedBg(data);
        return data;
      }
      return background;
    });

    setBackgrounds(updatedBackgrounds);
  };

  const handleUpdateBgData = async (dataToUpdate) => {
    console.log(dataToUpdate);

    // try {
    //   setIsLoading(true);
    //   const response = await updateModel(dataToUpdate);
    //   const updatedBackground = backgrounds.map((background) => {
    //     if (background._id === response.data._id) {
    //       return response.data;
    //     }
    //     return background;
    //   });
    //   setBackgrounds(updatedBackground);
    //   if (selectedBg) {
    //     setSelectedBg(response.data);
    //   }
    // } catch (err) {
    //   console.log("Error", err);
    // } finally {
    //   setIsLoading(false);
    // }
  };

  return (
    <>
      <div>
        <div className="mode">Background section</div>
        <div>
          {isLoading ? (
            <div>Loading...</div>
          ) : (
            <div className="bg-container">
              {backgrounds.map((background) => (
                <div
                  key={background._id}
                  className="bg-item"
                  //   onDragStart={() => handleModelDragStart(getModelKey(model))}
                  //   onDragOver={handleDragOver}
                  //   onDrop={() => handleModelDrop(getModelKey(model))}
                  //   onDragEnd={handleDragEnd}
                >
                  <div onClick={() => setSelectedBg(background)}>
                    <img src={background.image} alt={background.name} />
                  </div>
                  <div>{background.category}</div>
                  {/* <div
                    className="update-btn"
                    onClick={() => handleUpdateModelData(model)}
                  >
                    Update
                  </div> */}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      {selectedBg && (
        <Modal
          onClose={() => setSelectedBg(null)}
          modalStyle={{
            width: "100%",
            height: "100%",
            right: "0",
            top: "0",
            position: "relative",
          }}
        >
          <div className="close-btn" onClick={() => setSelectedBg(null)}>
            Close
          </div>
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              Loading...
            </div>
          ) : (
            <div className="bg-cat-list">
              {Object.keys(selectedBg.options).map((optionKey, idx) => (
                <div key={idx} className="bg-cat-container">
                  <img
                    src={selectedBg.options[optionKey].image}
                    alt={selectedBg.options[optionKey].name}
                  />
                  <div>{selectedBg.options[optionKey].name}</div>
                  <div>
                    <Textarea
                      onChange={(e: any) =>
                        updateBgPrompt(e.target.value, optionKey)
                      }
                      value={selectedBg.options[optionKey].prompt}
                      rows={6}
                    />
                  </div>
                  <div
                    className="update-btn"
                    onClick={() => {
                      handleUpdateBgData({
                        category: selectedBg.category,
                        categoryData: {
                          ["options"]: selectedBg.options[optionKey],
                        },
                      });
                    }}
                  >
                    Update
                  </div>
                </div>
              ))}

              {/* <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                multiple
                onChange={handleFileChange}
                style={{ display: "none" }}
              /> */}
            </div>
          )}
        </Modal>
      )}
    </>
  );
}
